//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscHand(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M3 14.3C3 16.27 3.68 18.2 4.91 19.74C6.57 21.81 9.04 23 11.7 23H15C18.31 23 21 20.31 21 17V7H19V11.81L17 11.46V3H15V11.1L13 10.75V1H11V10.4L9 10.05V2H7V15H9V12.08L19 13.84V17C19 19.21 17.21 21 15 21H11.7C9.65 21 7.75 20.08 6.47 18.48C5.52 17.3 5 15.81 5 14.3V11H3V14.3Z" fill="currentColor" /></svg>;
}
export default IconMiscHand;